import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b4f9f5fa&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=b4f9f5fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f9f5fa",
  null
  
)

export default component.exports